import React, { useState } from 'react';
import axios from 'axios';
import SearchForm from './components/SearchForm.jsx';
import ResultsDisplay from './components/ResultsDisplay.jsx';
import './App.css';

function App() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = async (prompt) => {
    setLoading(true);
    setError(null);
    setResults([]);
    setSearchQuery(prompt);

    try {
      console.log('Sending request to:', 'https://webscrapperserver-1036279390366.asia-south1.run.app/api/search');
      console.log('Request payload:', { prompt });
      
      const response = await axios.post('https://webscrapperserver-1036279390366.asia-south1.run.app/api/search', { prompt });
      
      console.log('Full response:', response);
      console.log('Response data:', response.data);
      console.log('Results:', response.data.results);
      console.log('Results type:', typeof response.data.results);
      console.log('Results is array:', Array.isArray(response.data.results));
      console.log('Results length:', response.data.results?.length);
      console.log('First result:', response.data.results?.[0]);
      console.log('First result type:', typeof response.data.results?.[0]);
      
      if (response.data && response.data.results) {
        setResults(response.data.results);
        if (response.data.results.length === 0) {
          setError('No email addresses found for this search. Try a different search term.');
        }
      } else {
        console.warn('No results found in response:', response.data);
        setError('No email addresses returned from server');
      }
    } catch (err) {
      console.error('API Error:', err);
      console.error('Error response:', err.response);
      console.error('Error message:', err.message);
      
      if (err.response) {
        setError(`Server Error: ${err.response.status} - ${err.response.data?.error || err.response.statusText}`);
      } else if (err.request) {
        setError('Network Error: Unable to reach the server');
      } else {
        setError(`Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <div className="container">
        <div className="header">
          <div className="title">Email Scraper</div>
          <div className="subtitle">Search and extract email addresses from websites</div>
        </div>
        
        <SearchForm onSearch={handleSearch} loading={loading} />
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <ResultsDisplay results={results} loading={loading} searchQuery={searchQuery} />
      </div>
    </div>
  );
}

export default App;
